export const SHAPES = {
    RECTANGLE: 'RECTANGLE',
    CIRCLE: 'CIRCLE',
    SQUARE: 'SQUARE',
}
